var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("circle", {
        attrs: {
          cx: "9",
          cy: "20",
          r: "1.4",
          stroke: _vm.color,
          "stroke-width": "1.6"
        }
      }),
      _c("circle", {
        attrs: {
          cx: "18",
          cy: "20",
          r: "1.4",
          stroke: _vm.color,
          "stroke-width": "1.6"
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M2.5 3h2.2l2.2 12.2a1.6 1.6 0 0 0 1.6 1.3h8.3a1.6 1.6 0 0 0 1.6-1.3L21 7H6",
          stroke: _vm.color,
          "stroke-width": "1.6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }